const formatNewsDate = function (item) {
    const value = item.datetime || item.date || "";
    const match = String(value).match(/^(\d{4})[-/.](\d{1,2})[-/.](\d{1,2})/);
    if (match) {
        return [match[1], match[2].padStart(2, "0"), match[3].padStart(2, "0")].join(".");
    }
    return item.date || "";
};

export default function NewsSection({
    bannerItems,
    bannerIndex,
    newsTabs,
    newsLists,
    activeNewsTab,
    activeNewsPage,
    newsPageSize,
    onNewsTabChange,
    onNewsPageChange,
    isNewsLoading
}) {
    const activeTab = newsTabs.find(function (tab) { return tab.key === activeNewsTab; }) || newsTabs[0];
    const activeList = (activeTab && newsLists[activeTab.key]) || [];
    const pageSize = newsPageSize || 4;
    const totalPages = Math.max(1, Math.ceil(activeList.length / pageSize));
    const currentPage = Math.min(totalPages, Math.max(1, activeNewsPage || 1));
    const startIndex = (currentPage - 1) * pageSize;
    const visibleItems = activeList.slice(startIndex, startIndex + pageSize);
    const emptyText = activeTab && activeTab.key === "notice" ? "暂无公告" : "暂无新闻";
    const pageNumbers = Array.from({length: totalPages}, function (_, index) { return index + 1; });

    const handlePageClick = function (page) {
        if (page === currentPage) return;
        onNewsPageChange(page);
    };

    return (
        <section className="section news" id="news" data-nav="新闻公告">
            <div className="news-content">
                <h2 className="section-title">新闻公告<small>News</small></h2>
                <div className="news-grid">
                    <div className="banner-card" id="bannerCard">
                        {bannerItems.map((item, index) => (
                            <picture key={item.id || item.src}>
                                {item.src2x ? <source media="(min-width: 1921px)" srcSet={item.src2x}/> : null}
                                <img
                                    className={bannerIndex === index ? "active" : ""}
                                    src={item.src}
                                    alt={item.alt}
                                />
                            </picture>
                        ))}
                    </div>
                    <div className="news-panel">
                        <div className="news-tabs" id="newsTabs" role="tablist" aria-label="新闻分类">
                            {newsTabs.map((tab) => (
                                <button
                                    key={tab.key}
                                    className={activeNewsTab === tab.key ? "active" : ""}
                                    type="button"
                                    role="tab"
                                    aria-selected={activeNewsTab === tab.key}
                                    data-news={tab.key}
                                    onClick={() => onNewsTabChange(tab.key)}
                                >
                                    {tab.label}
                                </button>
                            ))}
                        </div>
                        <ul className="news-list active" data-news-list={activeTab && activeTab.key}>
                            {isNewsLoading ? (
                                <li className="news-state"><span>新闻加载中...</span></li>
                            ) : visibleItems.length > 0 ? visibleItems.map((item) => (
                                <li key={item.id}>
                                    <a href={`#/newsdetail/${item.id}`}>
                                        <span className="news-item-main">
                                            <span className="news-item-tag">{item.category || "公告"}</span>
                                            <span className="news-item-title">{item.title}</span>
                                        </span>
                                        <time className="news-item-date">{formatNewsDate(item)}</time>
                                    </a>
                                </li>
                            )) : (
                                <li className="news-state"><span>{emptyText}</span></li>
                            )}
                        </ul>
                        {!isNewsLoading && activeList.length > 0 && (
                            <nav className="news-pager" aria-label="新闻分页">
                                <button
                                    className="news-pager-btn news-pager-prev"
                                    type="button"
                                    aria-label="上一页"
                                    disabled={currentPage <= 1}
                                    onClick={() => handlePageClick(currentPage - 1)}
                                >
                                    ‹
                                </button>
                                {pageNumbers.map((page) => (
                                    <button
                                        key={page}
                                        className={page === currentPage ? "news-pager-page active" : "news-pager-page"}
                                        type="button"
                                        aria-label={`第 ${page} 页`}
                                        aria-current={page === currentPage ? "page" : undefined}
                                        onClick={() => handlePageClick(page)}
                                    >
                                        <span className="news-pager-page-number">{page}</span>
                                    </button>
                                ))}
                                <button
                                    className="news-pager-btn news-pager-next"
                                    type="button"
                                    aria-label="下一页"
                                    disabled={currentPage >= totalPages}
                                    onClick={() => handlePageClick(currentPage + 1)}
                                >
                                    ›
                                </button>
                            </nav>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
}
